"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ITimelineEventPlayed = void 0;
var ITimelineEventPlayed;
(function (ITimelineEventPlayed) {
    ITimelineEventPlayed["UNPLAYED"] = "unplayed";
    ITimelineEventPlayed["PLAYING_UNSKIPPABLE"] = "unskippable";
    ITimelineEventPlayed["PLAYING_SKIPPABLE"] = "skippable";
    ITimelineEventPlayed["SKIPPED"] = "skipped";
    ITimelineEventPlayed["PLAYED"] = "played";
})(ITimelineEventPlayed = exports.ITimelineEventPlayed || (exports.ITimelineEventPlayed = {}));
//# sourceMappingURL=ITimelineEvent.js.map